module.exports = __webpack_public_path__ + "static/media/Google.b1776cd6.svg";